<!--采集配置页面-->
<template>
	<div class="collectionListBody">
		<div class="collectionTop">
			<el-button type="primary" size='small' @click='add'>添加</el-button>
		</div>
		<div class="collectionTable">
			<el-table :data="dataList" style="width: 100%" border>
				<el-table-column label="设备名称 " prop="deviceName">
				</el-table-column>
				<el-table-column label="设备ID" width='250' prop="serverInfo.deviceId">
				</el-table-column>
				<el-table-column label="设备组" prop="serverInfo.deviceGroup">
				</el-table-column>
				<el-table-column label="设备模板" prop="serverInfo.deviceTemplate">
				</el-table-column>
				<el-table-column label="设备子系列" prop="serverInfo.deviceSubseries">
				</el-table-column>
				<el-table-column label="创建时间">
					<template slot-scope="scope">
						<i class="el-icon-time"></i>
						<span style="margin-left: 10px">{{ new Date(scope.row.createTime).format('yyyy年MM月dd日hh时mm分ss秒') }}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button class="colorBlack" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button class='deleteButton' size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="width: 100%;display: flex;align-items: center;justify-content: center;padding-top: 1%;">
				<el-pagination background layout="prev, pager, next" :total="total" @current-change='clickChange' @prev-click="prevClick" @next-click="nextClick">
				</el-pagination>
			</div>
		</div>
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
			<el-form :model="form">
				<el-form-item label="设备名称" :label-width="formLabelWidth">
					<el-input v-model="form.name" autocomplete="on" maxlength="20" style='width: 55%;'></el-input>
				</el-form-item>
				<el-form-item label="设备子系列" :label-width="formLabelWidth">
					<el-select v-model="form.region" placeholder="请选择设备子系列">
						<el-option :label="item.name" :value="item.value" v-for='item in collectionMethod'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备ID" :label-width="formLabelWidth">
					<el-input v-model="form.deviceId" autocomplete="on" style='width: 55%;'></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="determine()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				dataList: [],
				pageIndex: 1,
				size: 10,
				total: 0,
				dialogFormVisible: false,
				form: {
					name: '',
					region: '',
					deviceId: '',
				},
				formLabelWidth: '120px',
				collectionMethod: [{
					name: 'kateNB3',
					value: 'kateNB3'
				}, {
					name: 'kateNB4',
					value: 'kateNB4',
				}], //采集方式
				dialogTitle: '添加设备',
				selectData: {}, //选中的数据
			}
		},
		created() {},
		mounted() {
			this.initData()
		},
		destroyed() {},
		computed: {},
		watch: {
			pageIndex(nv, ov) {
				this.initData()
			}
		},
		methods: {
			handleEdit(index, row) {
				//编辑
				this.dialogTitle = '编辑设备'
				this.dialogFormVisible = true
				this.selectData = row
				this.form = {
					name: row.deviceName,
					region: row.serverInfo.deviceSubseries,
					deviceId: row.serverInfo.deviceId,
				}
			},
			handleDelete(index, row) {
				this.$confirm('确认删除' + row.deviceName + '此设备吗')
					.then(_ => {
						this.$api.deviceCollectionConfigApi.deleteDeviceCollectionConfig(row.id, respon => {
							this.initData()
							this.$message({
								message: '删除成功',
								type: 'success'
							});
						}, failure => {
							this.$message({
								message: failure,
								type: 'warning'
							});
						})
					})
					.catch(_ => {});
			},
			prevClick() {
				//上一页
				if(this.pageIndex == 1) {
					this.$message('当前为第一页');
					return
				}
				this.pageIndex -= 1
			},
			clickChange(index){
				this.pageIndex=index
				//点击页数
			},
			nextClick() {
				if(this.pageIndex == Math.ceil(this.total / this.size)) {
					this.$message('当前为最后一页');
					return
				}
				this.pageIndex += 1
			},
			initData() {
				this.$api.deviceCollectionConfigApi.getDeviceCollectionConfigLimit(1, this.pageIndex, this.size, respon => {
					respon.dataList.forEach(item => {
						let tag = JSON.parse(item.tag)
						let deviceName = ''
						if(!isempty(tag.variableMap['InfoId'])) {
							deviceName = tag.variableMap['InfoId'].split('.')[0]
						}
						let serverInfo = tag.serverInfo
						item.serverInfo = serverInfo
						item.deviceName = deviceName
					})
					this.dataList = respon.dataList
					this.total = respon.total
				})
			},
			add() {
				this.dialogTitle = '添加设备'
				this.dialogFormVisible = true
			},
			noNempty(data) {
				let message = ''
				if(isempty(data.deviceId)) {
					message = '请填写设备ID'
				} else if(data.region) {
					message = '请填选择设备子系列'
				}
				if(!isempty(message)) {
					return true
				} else {
					this.$message({
						message: message,
						type: 'warning'
					});
					return false
				}

			},
			determine() {
				//确定
				if(this.noNempty(this.form)) {
					let serverInfo = '{"deviceId":"' + this.form.deviceId + '"}'
					let deviceName = ''
					if(this.dialogTitle == '添加设备') {
						deviceName = this.form.name
					} else {
						deviceName = this.selectData.deviceId
					}
					this.$api.deviceCollectionConfigApi.saveDeviceCollectionConfig(this.form.name, deviceName, 1, serverInfo, 'kate', 'kateNB', this.form.region, 'telecomIOT', respon => {
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						this.pageIndex = 1
						this.initData()
						this.form = {
							name: '',
							region: '',
							deviceId: '',
						}
					}, failure => {
						this.$message({
							message: failure,
							type: 'warning'
						});
					})
				}
				this.dialogFormVisible = false
			}
		}
	}
</script>

<style>
	.collectionListBody {
		background-color: white;
	}
	
	.collectionTop {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		height: 6%;
	}
	
	.collectionTop .el-button {
		margin-right: .2rem;
	}
	
	.collectionTable {
		width: 98%;
		margin: 0 auto;
	}
	
	.el-table--border th {
		text-align: center;
	}
	
	.el-dialog {
		width: 30%;
	}
</style>